var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar-brand-group" },
    [
      _c("router-link", { staticClass: "navbar-brand", attrs: { to: "/" } }, [
        _c("img", {
          attrs: { src: require("../assets/images/logo.png"), alt: "NIEM" }
        })
      ]),
      _c(
        "div",
        { attrs: { id: "site-name" } },
        [
          _c("router-link", { staticClass: "active", attrs: { to: "/" } }, [
            _vm._v("Mapping App")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }